import { withStyles } from '@ellucian/react-design-system/core/styles';
import React = require('react');
import GroupButton, { IGroupButtonResources } from './GroupButton';
import { Condition } from './models/Group';
import { IGroupButton } from './models/GroupButton';

interface IGroupButtonAreaProps {
    classes: any;
    className?: string;
    disableAddGroupFromSelectedRules?: boolean;
    groupButtons: IGroupButton[];
    onAddGroupFromSelectedRules: (groupId: string) => void;
    onAddRule: (groupId: string) => void;
    onAddSelectedRules: (groupId: string) => void;
    onChangeGroupCondition: (groupId: string, condition: Condition) => void;
    onSelectGroup: (groupId: string) => void;
    onUngroup: (groupId: string) => void;
    onUnselectGroup: (groupId: string) => void;
    readOnly?: boolean;
    ruleIndex?: string;
    selectedGroupIds: string[];
    strings: IGroupButtonResources;
    supportedGroupDepth?: number;
}

const styles = (_theme) => ({
    bottomGroupButtonArea: {
        display: 'flex',
        flexDirection: 'row',
        height: '16px',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
    },
    groupButtonAreaContainer: {
        position: 'relative',
    },
    groupButtons: {
        height: 'calc(100% + 7px)',
        position: 'relative',
    },
    groupButtonsContainer: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%',
    },
});

const groupWidth = 40;

class GroupButtonAreaInner extends React.Component<IGroupButtonAreaProps, any> {
    public static defaultProps = {
        readOnly: false,
        supportedGroupDepth: 3
    };

    constructor(props: IGroupButtonAreaProps) {
        super(props);

        this.state = {
            popoverAnchorElement: null,
            popoverOpen: false,
        };
    }

    public render() {
        const {
            classes,
            disableAddGroupFromSelectedRules,
            onAddGroupFromSelectedRules,
            onAddRule,
            onAddSelectedRules,
            onChangeGroupCondition,
            onSelectGroup,
            onUngroup,
            onUnselectGroup,
            groupButtons,
            readOnly,
            ruleIndex,
            selectedGroupIds,
            strings,
            supportedGroupDepth
        } = this.props;

        const width = `${Math.floor(100 / supportedGroupDepth)}%`;

        const depthMap: number[] = [];
        for (let i = 0; i < supportedGroupDepth; i++) {
            depthMap.push(i);
        }

        return (
            <div
                className={classes.container}
                style={{flex: `0 0 ${supportedGroupDepth * groupWidth}px`}}
            >
                <div className={classes.groupButtonsContainer}>
                    {depthMap.map((i) => {
                        const groupButton = groupButtons[i];

                        return (
                            <div
                                className={classes.groupButtonAreaContainer}
                                key={i}
                                style={{width}}
                            >
                                <div className={classes.groupButtons}/>
                                {groupButton && groupButton.showGroupButton &&
                                    <GroupButton
                                        depth={i}
                                        ruleIndex={ruleIndex}
                                        lineId={groupButton.groupId}
                                        // tslint:disable-next-line: max-line-length
                                        disableAddGroupFromSelectedRules={disableAddGroupFromSelectedRules || groupButton.disableAddGroup}
                                        disableAddSelectedRules={groupButton.disableAddSelectedRules}
                                        disableUngroup={groupButton.disableUngroup}
                                        center={groupButton.centerGroupButton}
                                        condition={groupButton.condition}
                                        groupId={groupButton.groupId}
                                        isSelected={selectedGroupIds.indexOf(groupButton.groupId) >= 0}
                                        onAddGroupFromSelectedRules={onAddGroupFromSelectedRules}
                                        onAddRule={onAddRule}
                                        onAddSelectedRules={onAddSelectedRules}
                                        onChangeGroupCondition={onChangeGroupCondition}
                                        onSelectGroup={onSelectGroup}
                                        onUngroup={onUngroup}
                                        onUnselectGroup={onUnselectGroup}
                                        strings={strings}
                                        readOnly={readOnly}
                                    />
                                }
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export const GroupButtonArea = [
    withStyles(styles),
].reduce((memo, hoc: any) => hoc(memo), GroupButtonAreaInner);

export default GroupButtonArea;
